module.exports = __webpack_public_path__ + "static/media/youtubeCloneImg.312406fb.png";